<template>
    <v-dialog 
      persistent 
      width="fit-content" 
      v-model="importProcessLoading"
    >
      <v-card 
        width="fit-content" 
        height="fit-content">
        <v-card-text v-if="importingErrors" class="px-3">
            <v-card-title class="text-body-1 error--text py-0 pt-3 justify-space-between">
                <span>{{ importingErrors.message }}</span>
                <v-btn @click="$emit('close')" v-if="importingErrors" icon class="">
                    <v-icon color="error">mdi-close-circle</v-icon>
                </v-btn> 
          </v-card-title>
          <v-card-text class="px-0 pb-0">
            <v-list-item class="px-0" two-line v-for="(error, index) in importingErrors.data" :key="index">
              <v-list-item-icon class="mx-auto px-3 my-auto">
                <v-icon color="error">mdi-alert-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Error on row {{ error.excelRowNumber }}: </v-list-item-title>
                <v-list-item-subtitle>
                  <span class="text-capitalize">{{ error.type }} for </span>
                  <span class="black--text">"{{ error.text }}"</span> 
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card-text>
        <v-card-text v-else class="text-center">
            <v-card-title class="text-body-1">
              {{ $t('customer.importingCustomers') }}
            </v-card-title>
            <v-progress-circular width="5" size="40" indeterminate color="success">
            </v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        importProcessLoading: {
            type: Boolean,
            required: true
        },
        importingErrors: {
            type: Object
        }
    },

    data() {
        return {
            
        }
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style scoped>

</style>